module.exports = __webpack_public_path__ + "static/media/rightAngleTriangle1.d1b54966.svg";